import React from "react";
import "./FloatingButton.css";
import AssistantLauncher from "../../assets/images/AIModal/AssistantLauncher.webp";
import { useTranslation } from "react-i18next";

const FloatingButton = ({ onClick, hideText }) => {
  const { t } = useTranslation();
  return (
    <button className="floating-button" onClick={onClick}>
      <div className="assistant-icon-container">
        <img
          src={AssistantLauncher}
          className="assistant-icon"
          alt={t("chat.launcherAlt")}
        />
      </div>

      <div className={`mobile-ai-launcher ${hideText ? "hidden" : ""}`}>
        <span className="btn-text">{t("chat.launcher")}</span>
      </div>
    </button>
  );
};

export default FloatingButton;
